const environment = import.meta.env.VITE_ENVIRONMENT || "dev";

export const authConfig = {
  // Microsoft SSO enabled in production and staging
  enableMicrosoft: environment === "prod" || environment === "staging",
  // Email/password enabled for local development and staging (for testing)
  enableEmailPassword: environment === "dev" || environment === "staging",
};
